
import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./RibbonBanner.module.scss";

export default function RibbonBanner() {
  const [ribbon, setRibbon] = useState<string | null>(null);

  useEffect(() => {
    axios.get("/ribbon/active").then(res => {
      if (res.data && res.data.content) {
        setRibbon(res.data.content);
      } else {
        setRibbon(null);
      }
    });
  }, []);

  // Add/remove 'with-ribbon' class to #root when ribbon is available
  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return;
    if (ribbon) {
      root.classList.add("with-ribbon");
    } else {
      root.classList.remove("with-ribbon");
    }
    // Clean up on unmount
    return () => {
      root.classList.remove("with-ribbon");
    };
  }, [ribbon]);

  return ribbon ? (
    <div className={styles.ribbonBanner}>{ribbon}</div>
  ) : null;
}
